import { render, staticRenderFns } from "./GiftEditPage.vue?vue&type=template&id=780f010a&scoped=true&"
import script from "./GiftEditPage.vue?vue&type=script&lang=js&"
export * from "./GiftEditPage.vue?vue&type=script&lang=js&"
import style0 from "./GiftEditPage.vue?vue&type=style&index=0&id=780f010a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780f010a",
  null
  
)

export default component.exports